



























































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { mdiSquareEditOutline, mdiMagnify, mdiReload } from "@mdi/js";
import PracticeInfo from "@/components/PracticeInfo.vue";
import AddPracticeForm from "@/components/AddPracticeForm.vue";

@Component({
  components: {
    PracticeInfo,
    AddPracticeForm
  }
})
export default class PracticeView extends Vue {
  @(namespace("practices").Action("getPractices")) actionGetPractices: any;
  editIcon: string = mdiSquareEditOutline;
  searchIcon: string = mdiMagnify;
  reloadIcon: string = mdiReload;
  search: any = "";
  loading: boolean = false;
  practices: any = [];
  headers: any = [
    { text: "S.No.", value: "id", align: "left" },
    { text: "Name", value: "name" },
    { text: "Email", value: "email" },
    { text: "URL", value: "url" },
    { text: "Active", value: "active", align: "center" },
    { text: "Actions", value: "actions", align: "center", sortable: false }
  ];
  activeSwitchLoading: boolean | string = false;
  addPracticeDialog: boolean = false;
  page: number = 1;
  pageCount: number = 0;
  itemsPerPage: number = 10;

  created() {
    this.$root.$on("toggleDialog", () => {
      this.addPracticeDialog = false;
    });
  }

  mounted() {
    this.loadContent();
  }

  async loadContent() {
    this.loading = true;

    try {
      this.practices = await this.actionGetPractices();
      this.loading = false;
    } catch (err) {
      console.log(err);
      this.loading = false;
    }
  }

  editClicked(item: any) {}
}
